import React, { useContext } from 'react';
import classNames from 'classnames';
import EnterpriseConfigureWrapper from 'components/EnterpriseConfigureWrapper';
import EnterpriseContext from '../RwcAnalytics/providers/Enterprise/Enterprise.context';

import './Configuration.styles.scss';

type ConfigurationProps = {
  className?: string;
};

const Configuration: React.FC<ConfigurationProps> = (props) => {
  const { className } = props;

  const classes = classNames('configuration', className);

  const {
    enterprise,
    updateBusinessUnits,
    updateMemberSeniorities,
    updateMemberLocations,
  } = useContext(EnterpriseContext);

  return (
    <div className={classes}>
      <EnterpriseConfigureWrapper
        enterprise={enterprise}
        updateBusinessUnits={updateBusinessUnits}
        updateMemberSeniorities={updateMemberSeniorities}
        updateMemberLocations={updateMemberLocations}
      />
    </div>
  );
};

export default Configuration;
